import React from 'react'
import { Banner } from '../ui'

function formatLongDate(value) {
  if (!value) return null
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function SessionLockBanner({ status, readyAt, completedAt, cancelledAt, viewingReport }) {
  if (viewingReport) {
    return (
      <Banner tone="info" icon="👁" data-testid="lock-banner">
        You're viewing {viewingReport}'s prep. This canvas is read-only.
      </Banner>
    )
  }

  if (status === 'ready') {
    const date = formatLongDate(readyAt)
    return (
      <Banner tone="warning" icon="✓" data-testid="lock-banner">
        Preparation locked{date ? ` on ${date}` : ''}. You can still fill in notes and agenda during the session.
      </Banner>
    )
  }

  if (status === 'cancelled') {
    const date = formatLongDate(cancelledAt)
    return (
      <Banner tone="error" icon="✕" data-testid="lock-banner">
        This 1:1 was cancelled{date ? ` on ${date}` : ''} and is now read-only.
      </Banner>
    )
  }

  if (status === 'completed') {
    const date = formatLongDate(completedAt)
    return (
      <Banner tone="info" icon="🔒" data-testid="lock-banner">
        This session was completed{date ? ` on ${date}` : ''} and is now read-only.
      </Banner>
    )
  }

  return null
}
